<template>
  <div>
    <b-card>
      <!-- Header -->
      <b-row class="justify-content-between mb-[24px]">
        <b-col
          cols="auto"
          class="flex items-center"
        >
          <b-button
            variant="primary"
            size="sm"
            class="rounded-lg mr-2"
            @click="$router.go(-1)"
          >
            <b-icon-chevron-left scale="1.3" />
          </b-button>
          <h4>
            <strong class="text-black text-2xl">Import Daftar Kontak Meta</strong>
          </h4>
        </b-col>
      </b-row>

      <!-- Filter -->
      <div class="mb-2">
        <b-dropdown
          id="dropdown-filter-main"
          class="filter"
          no-caret
          variant="outline-primary"
          toggle-class="text-decoration-none toggle-custom rounded-lg !py-[5px] !px-[10px]"
          no-close-on-click
        >
          <template #button-content>
            <div class="flex items-center gap-2">
              <span>Filter</span>
              <b-img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/filter-search.svg"
                height="20"
                alt="filter-search"
              />
            </div>
          </template>

          <b-dropdown
            v-for="(option, index) in filterImportMeta"
            :id="`dropdown-filter-${index}`"
            :key="index"
            class="w-100"
            toggle-class="text-left"
            variant="none"
            left
            no-caret
            dropright
            menu-class="filter-sub-menu p-0 rounded shadow"
          >
            <template #button-content>
              <div class="flex w-100 items-center justify-between">
                <span class="hover-salmon text-6">{{ option.label }}</span>
                <b-icon
                  icon="chevron-right"
                  class="ml-2 cursor-pointer"
                />
              </div>
            </template>
            <div class="filter-sub-content p-2 bg-white rounded min-w-[290px]">
              <!-- Checkbox list -->
              <div
                v-if="option.options && option.options.length > 0"
                class="overflow-y-auto max-h-[220px] mb-1"
              >
                <b-form-checkbox
                  v-for="(optionFilter, indexFilter) in option.options"
                  :key="indexFilter"
                  v-model="selectedFilter[option.key]"
                  :name="`checkbox-${option.key}-${indexFilter}`"
                  :value="optionFilter.id"
                  class="filter-sub-checkbox d-block mb-1 text-dark custom-control-primary"
                >
                  {{ optionFilter.name }}
                </b-form-checkbox>
              </div>
              <!-- Tanggal: Date Range Picker -->
              <div
                v-else-if="option.key === 'tanggal'"
                class="mb-1"
              >
                <date-range-picker
                  ref="datePicker"
                  v-model="dateRange"
                  :locale-data="locale"
                  :ranges="ranges"
                  opens="right"
                  class="w-100 rounded"
                >
                  <template #input>
                    <span class="small">
                      {{ dateRange.startDate && dateRange.endDate
                        ? `${formatDate(dateRange.startDate)} - ${formatDate(dateRange.endDate)}`
                        : 'Pilih Tanggal' }}
                    </span>
                  </template>
                </date-range-picker>
              </div>
              <!-- Footer: Reset + Terapkan -->
              <div class="grid grid-cols-9 gap-1 border-t w-full bg-white rounded-b ">
                <div class="col-span-3">
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="rounded w-full !px-[2px]"
                    @click="resetOneFilter(option.key)"
                  >
                    Reset
                  </b-button>
                </div>
                <div class="col-span-6">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="rounded w-full"
                    @click="applyOneFilter"
                  >
                    Terapkan
                  </b-button>
                </div>
              </div>
            </div>
          </b-dropdown>

          <div class="px-1 mt-1">
            <b-button
              size="sm"
              variant="outline-primary"
              class="rounded-lg w-full"
              @click="resetFilter"
            >
              Reset Filter
            </b-button>
          </div>
        </b-dropdown>
      </div>

      <!-- Table -->
      <BOverlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity="0.5"
        rounded="sm"
      >
        <div class="table-responsive">
          <table class="table b-table table-hover">
            <thead>
              <tr>
                <th style="width: 48px;">
                  <b-form-checkbox
                    :checked="isAllSelected"
                    :indeterminate="isIndeterminate"
                    class="custom-control-primary"
                    @change="toggleSelectAll"
                  />
                </th>
                <th class="font-bold text-black">
                  Nama
                </th>
                <th class="font-bold text-black">
                  Kontak
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in items"
                :key="item.id"
                class="cursor-pointer"
                @click="toggleRow(item.id)"
              >
                <td>
                  <b-form-checkbox
                    :checked="selectedIds.includes(item.id)"
                    class="custom-control-primary"
                    @change="toggleRow(item.id)"
                    @click.native.stop
                  />
                </td>
                <td class="align-middle text-black">
                  {{ item.name }}
                </td>
                <td class="align-middle text-black">
                  <span class="flex items-center gap-2">
                    <img
                      src="https://storage.googleapis.com/komerce/assets/icons/whatsapp.svg"
                      alt="icon whatsapp"
                      width="20"
                    >
                    {{ item.phone }}
                  </span>
                </td>
              </tr>
              <tr v-if="!isLoading && items.length === 0">
                <td
                  colspan="3"
                  class="text-center text-muted py-4"
                >
                  Tidak ada data yang ditampilkan.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer -->
        <b-row class="mt-2">
          <b-col
            cols="12"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center gap-2">
              <span class="text-[#333] font-semibold">Total data pelanggan:</span>
              <span class="text-[#F95031] font-bold">{{ selectedIds.length }}</span>
            </div>
            <b-button
              variant="primary"
              class="rounded-lg w-[150px]"
              :disabled="isImporting || selectedIds.length === 0"
              @click="sendDataImport"
            >
              <b-spinner
                v-if="isImporting"
                small
                class="mr-1"
              />
              {{ isImporting ? 'Memproses...' : 'Buat' }}
            </b-button>
          </b-col>
        </b-row>
      </BOverlay>
    </b-card>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  datePickerLocale, datePickerRanges,
} from '@/store/helpers'
import { SLASH_DATE, YEAR_MONTH_DAY } from '@/libs/formatDate'
import { filterImportMeta } from './config'
import { apiGetMetaContactList, apiImportContactFromKomship } from './service/api.list-contact.service'

export default {
  components: { DateRangePicker },
  data() {
    return {
      isLoading: false,
      isImporting: false,
      items: [],
      selectedIds: [],
      openFilterDropdownId: null,
      filterImportMeta,
      selectedFilter: {
        interaction_level: [],
      },
      dateRange: { startDate: null, endDate: null },
      locale: datePickerLocale,
    }
  },
  computed: {
    isAllSelected() {
      return this.items.length > 0 && this.selectedIds.length === this.items.length
    },
    isIndeterminate() {
      return this.selectedIds.length > 0 && this.selectedIds.length < this.items.length
    },
    allItemIds() {
      return this.items.map(item => item.id)
    },
    ranges() {
      const { startDate, endDate } = this.dateRange
      if (!startDate || !endDate) return datePickerRanges

      // Cek apakah tanggal yang dipilih cocok dengan salah satu preset
      const isPreset = Object.values(datePickerRanges).some(([s, e]) => (
        YEAR_MONTH_DAY(s) === YEAR_MONTH_DAY(startDate)
          && YEAR_MONTH_DAY(e) === YEAR_MONTH_DAY(endDate)
      ))

      if (isPreset) return datePickerRanges

      // Kalau tidak cocok, tambahkan "Custom Range" di bawah
      return {
        ...datePickerRanges,
        'Custom Range': [startDate, endDate],
      }
    },
    // Params yang dipakai oleh GET list dan POST import — satu sumber
    activeFilterParams() {
      const params = {}
      if (this.selectedFilter.interaction_level.length === 1) {
        const [level] = this.selectedFilter.interaction_level
        params.interaction_level = level
      }
      if (this.dateRange.startDate) {
        params.created_at_min = YEAR_MONTH_DAY(this.dateRange.startDate)
      }
      if (this.dateRange.endDate) {
        params.created_at_max = YEAR_MONTH_DAY(this.dateRange.endDate)
      }
      return params
    },
  },
  mounted() {
    this.getListContact()
    this.$root.$on('bv::dropdown::show', bvEvent => {
      const id = bvEvent.componentId
      if (id && id.startsWith('dropdown-filter-') && id !== 'dropdown-filter-main') {
        this.openFilterDropdownId = id
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      const id = bvEvent.componentId
      if (id && id.startsWith('dropdown-filter-') && id !== 'dropdown-filter-main') {
        this.openFilterDropdownId = null
      }
      if (id === 'dropdown-filter-main' && this.openFilterDropdownId) {
        bvEvent.preventDefault()
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('bv::dropdown::show')
    this.$root.$off('bv::dropdown::hide')
  },
  methods: {
    formatDate: SLASH_DATE,
    async getListContact() {
      try {
        this.isLoading = true
        const res = await apiGetMetaContactList(this.activeFilterParams)
        this.items = res.data?.data ?? []
        this.selectedIds = [...this.allItemIds] // default: semua terseleksi
      } catch {
        this.$toast_error({ message: 'Gagal mengambil data' })
      } finally {
        this.isLoading = false
      }
    },
    toggleSelectAll(checked) {
      this.selectedIds = checked ? [...this.allItemIds] : []
    },
    toggleRow(id) {
      const idx = this.selectedIds.indexOf(id)
      if (idx === -1) {
        this.selectedIds.push(id)
      } else {
        this.selectedIds.splice(idx, 1)
      }
    },
    applyOneFilter() {
      this.getListContact()
    },
    resetOneFilter(key) {
      if (key === 'interaction_level') this.selectedFilter.interaction_level = []
      if (key === 'tanggal') this.dateRange = { startDate: null, endDate: null }
      this.getListContact()
    },
    resetFilter() {
      this.selectedFilter = { interaction_level: [] }
      this.dateRange = { startDate: null, endDate: null }
      this.getListContact()
    },
    async sendDataImport() {
      if (this.isImporting || this.selectedIds.length === 0) return

      // except_ids = id yang TIDAK dicentang; [] = select all
      const exceptIds = this.isAllSelected
        ? []
        : this.allItemIds.filter(id => !this.selectedIds.includes(id))

      const payload = {
        except_ids: exceptIds, ...this.activeFilterParams, total_contact: this.selectedIds.length, type: 'komchat_meta',
      }

      try {
        this.isImporting = true
        await apiImportContactFromKomship(payload)
        this.$toast_success({ message: 'Data berhasil ditambahkan!' })
        this.$router.push({ name: 'grup-contact', params: { onImport: true, total: this.selectedIds.length } })
      } catch (err) {
        this.$toast_error({ message: err?.response?.data?.message || 'Data gagal ditambahkan' })
      } finally {
        this.isImporting = false
      }
    },
  },
}
</script>

<style scoped>
.filter-sub-menu {
  min-width: 280px;
  max-width: 320px;
  max-height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #dee2e6;
}
.filter-sub-checkbox {
  font-size: 0.875rem;
}
.filter-sub-checkbox.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #f95031;
  background-color: #f95031;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
